<template>
  <a-drawer
    :visible="visible"
    :mask-closable="canClose"
    :destroy-on-close="true"
    placement="right"
    :closable="false"
    :width="480"
    :body-style="{
      padding: '0px',
      marginBottom: '53px'
    }"
    :mask-style="{
      backgroundColor: 'transparent'
    }"
    @update:visible="visible => $emit('update:visible', visible)"
    @close="isBestCaseCardVisible = false"
  >
    <template #title>
      <div
        v-if="editingParams"
        class="drawer-title"
      >
        <div class="left">
          <IconFont
            :type="editingParams.iconName"
            class="icon"
          />
          {{ $t(`okr.editDialogTitle.${editingParams.type}`) }}
        </div>
        <!-- <a-button
          v-if="editingParams.type !== EDIT_PERSONAL_OBJECTIVE && editingParams.type !== EDIT_ORGANIZATIONAL_OBJECTIVE"
          type="link"
          :style="{ padding: 0 }"
          @click="showBestCaseCard"
        >
          {{ $t('okr.learnBestCase') }}
        </a-button> -->
      </div>
    </template>
    <template v-if="editingParams">
      <ObjectiveForm
        v-if="editingParams.type === CREATE_OBJECTIVE"
        v-model:can-close="canClose"
        :okr-list-id="editingParams.okrListId"
        v-bind="$attrs"
        @cancel="onCancel"
      />
      <EditObjectiveForm
        v-else-if="editingParams.type === EDIT_OBJECTIVE"
        v-model:can-close="canClose"
        :objective-id="editingParams.objectiveId"
        :init-form="editingParams.data"
        v-bind="$attrs"
        @cancel="onCancel"
      />
      <KeyResultForm
        v-else-if="editingParams.type === CREATE_KEY_RESULT"
        v-model:can-close="canClose"
        :objective-id="editingParams.objectiveId"
        v-bind="$attrs"
        @cancel="onCancel"
      />
      <KeyResultForm
        v-else-if="editingParams.type === EDIT_KEY_RESULT"
        v-model:can-close="canClose"
        :init-form="editingParams.data"
        v-bind="$attrs"
        @cancel="onCancel"
      />
      <EditPersonalObjectiveForm
        v-else-if="editingParams.type === EDIT_PERSONAL_OBJECTIVE || editingParams.type === EDIT_ORGANIZATIONAL_OBJECTIVE"
        v-model:can-close="canClose"
        :okr-list-id="editingParams.okrListId"
        :init-form="editingParams.data"
        v-bind="$attrs"
        :type="editingParams.type"
        @cancel="onCancel"
      />
    </template>
    <BestCasePopCard
      v-if="isBestCaseCardVisible"
      v-model:isVisible="isBestCaseCardVisible"
    />
  </a-drawer>
</template>

<script>
import { ref, watch, onBeforeUnmount } from 'vue'
import { useGtag } from 'vue-gtag-next'

import * as EDIT_TYPE from '@/constants/okr-edit-type'
import ObjectiveForm from './ObjectiveForm'
import EditObjectiveForm from './EditObjectiveForm'
import KeyResultForm from './KeyResultForm'
import EditPersonalObjectiveForm from './EditPersonalObjectiveForm'
import BestCasePopCard from './BestCasePopCard'

export default {
  name: 'EditDrawer',
  components: {
    ObjectiveForm,
    EditObjectiveForm,
    KeyResultForm,
    EditPersonalObjectiveForm,
    BestCasePopCard
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    editingParams: {
      type: Object,
      default: () => null
    }
  },
  emits: [
    'update:visible'
  ],
  setup (props, { emit }) {
    const { event } = useGtag()
    const canClose = ref(true)
    const isBestCaseCardVisible = ref(false)

    function onCancel () {
      emit('update:visible', false)
    }

    function showBestCaseCard () {
      if (isBestCaseCardVisible.value) {
        return
      }
      isBestCaseCardVisible.value = true
      if (process.env.VUE_APP_GTAG_ID) {
        event('view_best_case')
      }
    }

    onBeforeUnmount(() => {
      window.onbeforeunload = null
    })

    watch(() => props.visible, val => {
      if (!val) {
        canClose.value = true
      }
    })

    watch(canClose, val => {
      if (!val) {
        window.onbeforeunload = function () {
          return true
        }
      } else {
        window.onbeforeunload = null
      }
    })

    return {
      ...EDIT_TYPE,
      isBestCaseCardVisible,
      showBestCaseCard,
      onCancel,
      canClose
    }
  }
}
</script>

<style lang="less" scoped>
.drawer-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 32px;
  .left {
    display: flex;
    align-items: center;
  }
  .icon {
    margin-right: 8px;
  }
}
</style>
